import { Injectable } from '@angular/core';
import { BrokerService } from './broker.service';
import { Router } from '@angular/router';
import { SesionService } from './sesion.service';
import { LoadingService } from './loading.service';

interface Baloto {
  sessionId: any;
  code: any;
}

@Injectable({
  providedIn: 'root'
})

export class BalotoService {

  baloto: any;
  balotoData: any;

  constructor(
    public broker: BrokerService,
    public router: Router,
    public sesion: SesionService,
    public loading: LoadingService
  ) { }

  validarCodigo() {
    this.loading.open( 'Por favor espera un momento...' , 'Estamos validando tu código.' );
    this.baloto = null;
    if (this.balotoData.code) { this.balotoData.code = this.balotoData.code.toUpperCase(); }
    this.broker.redimirBaloto( this.balotoData ).subscribe( ( data: any ) => {

      if(data.oneShotCode == -1 || data.oneShotCode == null){
        if(data.oneShotCode == -1){
          this.baloto = 'BAD';
          setTimeout( () => {
            this.loading.close();
          }, 3000);
        } else if(data.oneShotCode == null){
          this.baloto = 'REP';
          setTimeout( () => {
            this.loading.close();
          }, 3000);
        }
      }
      else {
        this.loading.close();
        this.baloto = 'OK';
        this.router.navigate(['/oneshot/confirmacion'], { queryParams: {product : this.sesion.product} });
      }
    },
    (error) => {
      this.baloto = 'BAD';
    });
  }
}